import { Box, Typography, useTheme } from "@mui/material";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import React from "react";
import { IStandardCardProps } from "./interfaces/ICardsProps";
import { CSS_CONSTANTS } from "../../constants/cssConstants";

export const StandadCard: React.FC<IStandardCardProps> = (props) => {
  const {
    heading,
    rightHeading,
    sx,
    variant = "normal",
    renderWithoutCard = false,
    headingCenter = false,
    isDivider = true,
  } = props;
  const theme = useTheme();

  const isNode = React.isValidElement(rightHeading);

  if (renderWithoutCard) {
    return (
      <Box>
        <Box
          display="flex"
          justifyContent={headingCenter ? "center" : "space-between"}
          alignItems="center"
        >
          {heading ? (
            <Typography variant="h2" fontSize={"1.4rem"} fontWeight={"700"}>
              {heading}
            </Typography>
          ) : (
            <Box></Box>
          )}
          {isNode && <Box>{rightHeading}</Box>}
          {!isNode && (
            <Typography variant="body1" fontWeight={"400"}>
              {rightHeading}
            </Typography>
          )}
        </Box>
        {heading && (
          <Divider
            sx={{
              mt: 1,
              mb: 1,
              [theme.breakpoints.up("md")]: {
                mt: 0.8,
                mb: 0.8,
              },
              [theme.breakpoints.up("lg")]: {
                mt: 1,
                mb: 1,
              },
              [theme.breakpoints.up("xl")]: {
                mt: 1.5,
                mb: 1.5,
              },
            }}
          />
        )}
        {props.children}
      </Box>
    );
  }

  return (
    <Card
      sx={{
        margin: 0,
        borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        padding: "1rem",
        boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",
     border: `1px solid ${theme.palette.grey[300]}`,
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        [theme.breakpoints.up("md")]: {
          padding: variant === "normal" ? "1.1rem" : "10px",
  borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        },
        [theme.breakpoints.up("lg")]: {
          padding: variant === "normal" ? "1.2rem" : "10px",
          borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        },
        [theme.breakpoints.up("xl")]: {
          padding: variant === "normal" ? "1.2rem" : "10px",
          borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        },

        ...sx,
      }}
    >
         <Box
          display="flex"
          justifyContent={headingCenter ? "center" : "space-between"}
          alignItems="center"
        >
          {heading ? (
            <Typography variant="body1" fontSize={CSS_CONSTANTS.MAIN_HEADING_3} fontWeight={"600"}>
              {heading}
            </Typography>
          ) : (
            <Box></Box>
          )}
          {isNode && <Box>{rightHeading}</Box>}
          {!isNode && (
            <Typography variant="body1" fontWeight={"400"}>
              {rightHeading}
            </Typography>
          )}
        </Box>
       {heading && (
          <Box
            sx={{
              mt: 1,
              mb: 1,
              [theme.breakpoints.up("md")]: {
                mt: 0.8,
                mb: 0.8,
              },
              [theme.breakpoints.up("lg")]: {
                mt: 1,
                mb: 1,
              },
              [theme.breakpoints.up("xl")]: {
                mt: 1.5,
                mb: 1.5,
              },
            }}
          />
        )}
        <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
          {props.children}
        </Box>
    </Card>
  );
};
